import { APIs } from "../utils/worker";
const { baseURL } = APIs;
const urls = {
  GET_DRIVER_LIST: baseURL + "/driver-service/v1/driver/getdriver/",
  PUT_DRIVER_DETAILS: baseURL + "/vehicle-service/v1/vehicle/",
  CREATE_ROUTE: baseURL + "/route-service/v1/route/from/",
  UPDATE_SORTING_GUIDE:
    baseURL + "/sorting-service/v1/sorting-guide/premise-id",
  GET_SORTING_GUIDE_DETAIL:
    baseURL + "/sorting-service/v1/sorting-guide/sorting-guide-id/",
  GET_SORTING_NAME_BASED_DETAIL:
    baseURL + "/sorting-service/v1/sorting-guide/premise-id/",
  GET_CLIENT_DETAILS: baseURL + "/client-onboard/v1/organizations/",
  PATCH_CLIENT_DETAILS: baseURL + "/client-onboard/v1/organizations/",
  UPDATE_STAFF: baseURL + "/staff-service/v1/staff",
  VERIFY_GST: baseURL + "/cp-onboarding/v1/gst/",
  PINCODE_MAPPING_PATCH: baseURL + "/client-onboard/v1/pin-code-mapping/",
  GET_CLIENT_TABLE_HO: baseURL + "/client-onboard/v1/ho/clients",
  GET_CLIENT_TABLE: baseURL + "/client-onboard/v1/cp/clients",
  GET_BANK_DETAILS_BY_IFSC: baseURL + "/cp-onboarding/v1/ifscdetail",
  DISABLE_CLIENT: baseURL + "/client-onboard/v1/disable/",
  VERIFY_EMAIL: baseURL + "/staff-service/v1/verifykey",
  VERIFY_PHONE_NUM: baseURL + "/cp-onboarding/v1/verifyotp",
  SEND_SMS_PHONE: baseURL + "/cp-onboarding/v1/sendOtp",
  SEND_SMS_EMAIL: baseURL + "/cp-onboarding/v1/sendmail",
  GET_ALL_STAFF: baseURL + "/staff-service/v1/staff",
  GET_STAFF_ROLES: baseURL + "/staff-service/v1/staff/roles",
  GET_NOTIFICATION1: baseURL + "/notification-service/v1/getNotification/",
  GET_NOTIFICATION: baseURL + "/notification-service/stream-flux/",
  VIEW_NOTIFICATION: baseURL + "/notification-service/v1/updateView",

  // VERIFY_PHONE_OTP: baseURL + "/v1/driver/verifysms",
  VERIFY_PHONE_OTP: baseURL + "/cp-onboarding/v1/verifyotp",
  VERIFY_EMAIL_OTP: baseURL + "/cp-onboarding/v1/verifymail",

  // VERIFY_EMAIL_OTP: baseURL + "/v1/driver/verifymail",
  UPLOAD_CLIENT_DOC: baseURL + "/file-service/v1/client/document",
  UPLOAD_DOC_TO_CLIENT: baseURL + "/client-onboard/v1/document/",
  ADD_CLIENT_RATE_CARD: baseURL + "/ratecard-service/v1/ratecard",
  GET_CLIENT_RATE_CARD: baseURL + "/ratecard-service/v1/ratecard/client/",
  APPROVE_CLIENT: baseURL + "/ratecard-service/v1/ratecard/",
  REJECT_CLIENT: baseURL + "/client-onboard/v1/client/decline",
  GET_RATE_CARD: baseURL + "/ratecard-service/v1/ratecard/calculate/from/",
  GET_NEW_PASSOWORD_DETAILS: baseURL + "/account-service/v1/user/",
  CREATE_NEW_PASSWORD: baseURL + "/cp-onboarding/v1/reset/password",
  //--Middle Mile--//
  SORT_SHIPMENT: baseURL + "/sorting-service/v1/sorting-guide/sort-plan",
  CHANGE_SORT_SHIPMENT_STATUS:
    baseURL + "/sorting-service/v1/sorting-guide/sort-plan",
  GET_MM_ROUTE: baseURL + "/route-service/v1/getroutebypremise/",
  CREATE_BAG: baseURL + "/bagging-service/v1/bag",
  GET_ELIGIBLE_DESTINATION_HUB:
    baseURL + "/bagging-service/v1/bag/destinationhublist",
  GET_ALL_BAGS: baseURL + "/bagging-service/v1/bag",
  GET_BAG_DESTINATION: baseURL + "/route-service/v1/route/from/",
  POST_TRIP_GENERATE: baseURL + "/lcr-service/v1/trip/vehicle",
  POST_ELIGIBLE_BAGS: baseURL + "/out-scan-service/v1/trip/",
  GET_ALL_ROUTS: baseURL + "/route-service/v1/getroutebypremise/",
  POST_LCR: baseURL + "/lcr-service/v1/lcr",
  POST_CONSOLIDATE_LCR: baseURL + "/lcr-service/v1/consolidate/lcr",
  PATCH_CONSOLIDATED_LCR: baseURL + "/lcr-service/v1/consolidated/lcr/",
  GET_LCR_LIST: baseURL + "/lcr-service/v1/consolidated/lcr/list",
  GET_TRIP_LIST: baseURL + "/lcr-service/v1/trip/list",
  UPDATE_TRIP_LIST: baseURL + "/lcr-service/v1/transit/trip/list",
  GET_TRIP_COUNT: baseURL + "/lcr-service/v1/trip/count/tripId",
  POST_TRIP_ID: baseURL + "/lcr-service/v1/trip/vehicle",
  GET_ALL_VEHICLES: baseURL + "/vehicle-service/v1/availableVehicles",

  //----//
  GET_ALL_CP_FROM_HUB: baseURL + "/manifest-service/v1/consolidated-manifest/",
  GET_CP_WISE_MANIFEST:
    baseURL + "/manifest-service/v1/manifest/status/MANIFESTED/hub/",
  AUDIT_POST: baseURL + "/audit-service/v1/audit/",

  GET_SHIPMENT: baseURL + "/audit-service/v1/audit/shipment-details/",
  // https://smcs-dev.hutechweb.com/smcs-webapp/audit-service/v1/audit/shipment-details/%7BawbNo%7D

  GET_TRACKER: baseURL + "/track/v1/awbnumber/",

  GET_CP_DETAILS: baseURL + "/premise-service/v1/cpDetails/",

  //LCR IN_SCAN
  GET_LCR_IN_SCAN_LIST: baseURL + "/lcr-service/v1/lcr/list/toPremise",
  SCAN_LCR_IN_SCAN_LIST: baseURL + "/lcr-service/v1/lcr",

  //LCR Bag list
  // GET_LCR_BAG_LIST: baseURL + "/bagging-service/v1/bag/update/bag/list",

  GET_LCR_SCANNED_PACKETS: baseURL + "/v1/packets/in-scan/list/",

  GET_LCR_BAG_LIST: baseURL + "/lcr-service/v1/lcr/",
  GET_LCR_SCANNED_BAGS: baseURL + "/bagging-service/v1/bag/in-scan/list",
  GET_BAGGED_CONTENTS: baseURL + "/bagging-service/v1/bag/",
  GET_PACKET_CONTENTS: baseURL + "/v1/packets/",
  GET_ROUT_BY_ID: baseURL + "/route-service/v1/getroutebyid/",
  PUT_TRIP_STATUS: baseURL + "/lcr-service/v1/trip/",
  //BAG SCAN
  UPDATE_ALL_BAGs: baseURL + "/bagging-service/v1/bag/update/bag/list",
  UPDATE_SINGLE_BAG: baseURL + "/bagging-service/v1/update/bag/list",

  UPDATE_ALL_PACKETS: baseURL + "/v1/packets/update/packets/status",

  GET_BAG_OPENED: baseURL + "/bagging-service/v1/bag/status/opened",

  //PRODUCT
  GET_ALL_PRODUCTS: baseURL + "/v1/item",
  GET_PRODUCTS_BY_PREMISE: baseURL + "/v1/item/eligibility",
  GET_PRODUCT_BY_ID: baseURL + "/v1/item/",
  GET_PRODUCT_BY_ORDER_ID: baseURL + "/v1/order/orderdetailOf/",
  ADD_TO_CART: baseURL + "/v1/cart/add",
  GET_CART_DETAILS: baseURL + "/v1/cart",
  UPDATE_DELIVERY_DETAILS: baseURL + "/v1/cart/delivery",
  REMOVE_ITEM: baseURL + "/v1/cart/remove/item/",
  UPDATE_PAYMENT_DETAILS: baseURL + "/v1/cart/payment",
  PLACE_ORDER: baseURL + "/v1/order",
  UPDATE_ITEM_DATA: baseURL + "/v1/cart/edit-quantity",
  ORDER_LIST: baseURL + "/v1/order/orders",
  ORDER_DETAILS_BY_ID: baseURL + "/v1/order/",
  MODE_PAYMENT_DROPDOWN: baseURL + "/v1/cart/mode-of-payment",

  //SORT TO CP
  GET_CP_WISE_SORTING_DATA: baseURL + "/v1/sort-and-out-scan",
  UPDATE_CP_WISE_SORTING_STATUS: baseURL + "/v1/sort-and-out-scan/",

  //lastMile
  GET_CP_IN_SCAN_LIST:
    baseURL + "/last-mile-manifest-service/v1/manifest/toPremise/",
  GET_MANIFEST_LIST: baseURL + "/last-mile-manifest-service/v1/manifest",

  GET_CP_MANIFEST_LIST:
    baseURL + "/last-mile-manifest-service/v1/manifest/toPremise/",
  DELETE_DRS: baseURL + "/drs-service/v1/delete/drs/",

  // /premise/areas/{premiseId}
  GET_DELIVERY_AREAS: baseURL + "/premise-service/premise/areas/",
  GET_VIEW_ALL_DELIVERY_AREAS: baseURL + "/pincode-service/v1/virtual-areas",
  CREATE_DELIVERY_AREA: baseURL + "/pincode-service/v1/virtual-area",
  GET_VIRTUAL_AREA: baseURL + "/pincode-service/v1/virtual-area/",
  DELETE_VIRTUAL_AREA: baseURL + "/pincode-service/v1/virtual-area/",
  POST_ELIGIBLE_SHIPMENTS: baseURL + "/drs-service/v1/elligible/shipments",
  POST_GENERATE_DRS: baseURL + "/drs-service/v1/drs",
  UPDATE_VIRTUAL_AREA: baseURL + "/pincode-service/v1/virtual-area/",
  GET_DELIVERY_BOY:
    baseURL + "/driver-service/v1/driver/getDeliveryBoy/details",
  GET_DRS_LIST: baseURL + "/drs-service/v1/drs/premise/list/",
  GET_SINGLE_DRS: baseURL + "/drs-service/v1/drs/",
  GET_POD: baseURL + "/drs-service/v1/drs/pod/",
  PATCH_DRS_SHIPMENT: baseURL + "/drs-service/v1/drs/",
  PENDING_DRS: baseURL + "/shipment-service/v1/shipment/pending",

  REMOVE_VIRTUAL_AREA: baseURL + "/premise-service/premise/area/status",

  // IN_CP_GET_TABLE: baseURL + "/v1/last-mile/in-scan/",
  // smcs-webapp/pincode-service/v1/virtual-area/{virtualAreaId}

  //PACKERING
  GET_CP_PACKETS: baseURL + "/v1/packets/eligible/packets",

  CREATE_PACKETS: baseURL + "/v1/packets/",

  UPDATE_PACKET: baseURL + "/v1/packets/",
};
export default urls;
